import { useMemo } from 'react';
import { ILoadableButtonProps } from '@components';
import {
  ButtonsWrapper,
  Container,
  StyledLoadableButton,
} from './index.styles';

interface ITableFooterWithActionsProps {
  buttons?: Array<ILoadableButtonProps>;
  className?: string;
}

export function TableFooterWithActions({
  buttons,
  className,
}: ITableFooterWithActionsProps) {
  let renderedButtons = useMemo(
    () =>
      buttons?.map((props: ILoadableButtonProps) => (
        <StyledLoadableButton key={props.title} {...props}>
          {props?.title}
        </StyledLoadableButton>
      )),
    [buttons],
  );

  if (!buttons?.length) {
    return <></>;
  }

  return (
    <Container className={className}>
      <ButtonsWrapper>{renderedButtons}</ButtonsWrapper>
    </Container>
  );
}
